var CommentsList = React.createClass({
  propTypes: {
    comments: React.PropTypes.arrayOf(React.PropTypes.object),
    onReplySaved: React.PropTypes.func.isRequired,
    showReplyLink: React.PropTypes.bool,
    currentUserID: React.PropTypes.number,
    isResolutionAllowed: React.PropTypes.bool
  },
  getDefaultProps() {
    return {
      comments: []
    }
  },
  render() {
    let comments = this.props.comments.map(c =>
      <Comment
        comment={c}
        key={c.id}
        showReplyLink={this.props.showReplyLink}
        onReplySaved={this.props.onReplySaved}
        currentUserID={this.props.currentUserID}
        isResolutionAllowed={this.props.isResolutionAllowed}/>
    );

    return (
      <div>
        {comments}
      </div>
    );
  }
});